import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import moment from "moment";

import useCountries from "../../../services/settings/useCountries";

const shortenCountryName = (countryName) => {
  const firstBracket = countryName.indexOf("(", 0) > 0 ? countryName.indexOf("(", 0) : countryName.length;
  const firstOf = countryName.indexOf("of", 0) > 0 ? countryName.indexOf("of", 0) : countryName.length;
  const firstComa = countryName.indexOf(",", 0) > 0 ? countryName.indexOf(",", 0) : countryName.length;

  return (countryName.substr(0, Math.min(firstBracket, firstOf, firstComa)));
}

const CountryNameTooltip = (props) => {
  const countryCode = props.countryCode;
  const departureTime = props.departureTime;
  const tooltipSuffix = props.suffix || "";

  const [load, setLoad] = useState("WAIT");
  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const countryName = useCountries({ queryClient, extraKeys: [countryCode]});

  let toolTipText = "Retrieving info...";

  if (countryName.error) {
    toolTipText = "...";
  }

  if (countryName.data) {
    const rows = countryName.data;
    if (rows) {
      toolTipText = (
        <Fragment>
          <span>
            {
              rows.map((row, i) => {
                if (departureTime) {
                  const fromTimeMoment = moment(departureTime, "HH:mm").add(-row.permitPreDepartureValidityHours, "hour");
                  const fromTime = fromTimeMoment.format("HH:mm");
                  const toTime = moment(departureTime, "HH:mm").add(row.permitValidityHours * 60 - 1, "minute").format("HH:mm");
                  const plusDays = fromTimeMoment.hour() + row.permitValidityHours > 24 ? 1 : 0;
                  const plusDaysSuffix = plusDays + Math.floor(row.permitValidityHours / 24) > 0 ? `+${plusDays + Math.floor(row.permitValidityHours / 24) - 1}` : "";
                  const shortCountryName = shortenCountryName(row.countryName)
                  return (
                    <span>
                      Validity for <em><strong>{shortCountryName}</strong></em> is {row.permitPreDepartureValidityHours} hour{row.permitPreDepartureValidityHours > 1 ? "s" : ""} prior to departure to {row.permitValidityHours} hours after departure ({fromTime} - {toTime} {plusDaysSuffix})
                    </span>
                  );
                }
                return((i > 0 ? ", " : "") + row.countryName);
              })
            }
          </span>
          <span>{tooltipSuffix}</span>
        </Fragment>
      );
    } else {
      toolTipText = "";
    }
  };

  return (
    <span>{toolTipText}</span>
  );
}

export default CountryNameTooltip;